import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SessionStorageService} from '../../services/session-storage.service';

@Component({
    selector: 'app-intl-tel-input',
    templateUrl: './intl-tel-input.component.html',
    styleUrls: ['./intl-tel-input.component.scss']
})
export class IntlTelInputComponent implements OnInit, AfterViewInit {
    @Input() errors;
    @Input() isRequired = true;
    @Input() number: any;
    @Input() submitted = false;

    @Output() setValidNumber: EventEmitter<any> = new EventEmitter<any>();
    @Output() setInValid: EventEmitter<any> = new EventEmitter<any>();

    private readonly defaultLanguage = 'en';
    initialize: boolean;
    defaultCountryCode = 'hk';
    intlObject: any;
    isValid = false;
    validationError: string;
    errorMap = [
        {en: '', cn: ''},
        {en: 'Invalid country code', cn: '国家/地区代码无效'},
        {en: 'Too short', cn: '太短'},
        {en: 'Too long', cn: '太长'},
        {en: 'Invalid number', cn: '无效号码'}
    ];

    constructor(private translate: TranslateService, private sessionStorageService: SessionStorageService) {
        this.initialize = true;
        this.defaultLanguage = sessionStorageService.getLanguageSession();
        this.number = {
            countryCode: this.defaultCountryCode,
            number: ''
        };
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
            // setTimeout(() => this.numberInValid(false), 1550);
    }

    getNumber(number: string) {
        this.setValidNumber.emit({
            countryCode: this.intlObject.intlTelInput('getSelectedCountryData').iso2,
            number: number.replace('+' + this.intlObject.intlTelInput('getSelectedCountryData').dialCode, '')
        });
    }

    numberInValid(numberIsValid: boolean) {
        let error;
        this.isValid = this.intlObject.intlTelInput('isValidNumber');
        // this.setInValid.emit(null);
        this.validationError = this.errorMap[0][this.defaultLanguage];
        this.getNumber(this.intlObject.intlTelInput('getNumber'));
        if (this.isRequired) {
            this.validationError = this.intlObject.intlTelInput('getValidationError') == 0
                ? this.errorMap[4][this.defaultLanguage]
                : this.errorMap[this.intlObject.intlTelInput('getValidationError')][this.defaultLanguage];
            error = this.isValid ? null : {'invalid': true};
            this.setInValid.emit(error);
        } else {
            if (this.intlObject.intlTelInput('getNumber') != '') {
                this.validationError = this.intlObject.intlTelInput('getValidationError') == 0
                    ? this.errorMap[4][this.defaultLanguage]
                    : this.errorMap[this.intlObject.intlTelInput('getValidationError')][this.defaultLanguage];
                error = this.isValid && !this.isRequired ? null : {'invalid': true};
                this.setInValid.emit(error);
            } else {
                this.isValid = true;
                this.setInValid.emit(null);
            }
        }
    }

    telInputObject(obj: any) {
        this.intlObject = obj;
        this.intlObject.intlTelInput('setCountry', this.defaultCountryCode);
        setTimeout(() => {
            if (this.number != null) {
                this.intlObject.intlTelInput('setCountry', this.number.countryCode == undefined ? this.defaultCountryCode : this.number.countryCode);
            }
            if (this.number != null) {
                this.intlObject.intlTelInput('setNumber', this.number.number == undefined ? '' : this.number.number);
                this.isValid = this.isRequired && (this.intlObject.intlTelInput('getValidationError') == 0);
                this.numberInValid(this.isValid);
            }
        }, 1300);
    }

    onCountryChange(obj: any) {
        this.intlObject.intlTelInput('setNumber', this.initialize == true ? '' : this.number.number == undefined ? '' : this.number.number);
        this.initialize = false;
    }
}
